export default "__VITE_ASSET__CGmT18tN__"